export default __webpack_public_path__ + "static/media/s-15.68ecbca9.jpg";